import React from 'react';
import { useDispatch } from 'react-redux';
import {
  Button,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';

import {
  HiOutlineCloudDownload,
} from 'react-icons/hi';
import { Page, DatePicker } from 'ui/components';
import { formatDate } from 'utilities/common';

import { Report } from 'services/action';
import Table from './component/table';

const initialState = {
  filter: {
    date: new Date(),
    format: formatDate(new Date(), 'YYYY'),
  },
  isLoading: false,
  data: null
};

const ReportReceivableCustomerScreen = () => {
  const Dispatch = useDispatch();
  const [{ data, filter }, setState, ] = React.useState(initialState);

  const $handleDownload = async() => {
    const params = {
      yearly: filter?.format,
      downloadable: true
    }

    await Dispatch(Report.$receivableCustomer(params));
  }

  const $onLoad = async() => {
    const params = {
      yearly: filter?.format,
    }
    const result = await Dispatch(Report.$receivableCustomer(params));
    if (result?.message === 'success') {
      setState((prevState) => ({
        ...prevState,
        data: result?.data
      }));
    }
  }

  React.useEffect(() => {
    $onLoad();
  }, [filter]);

  return (
    <Page className="bordered">
      <Page.Header title="Laporan Omset Customer"  />

      <div className='row bg-white px-2 m-0'>
        <div className='col-12'>
          <div className='px-3'>
            <div className="d-flex table-tools align-items-center justify-content-end">
              <div className="d-flex align-items-center">
                <div className="mb-3">
                  <label class="form-label fs-8">Pilih Tahun</label>
                  <DatePicker
                    selectionMode="year"
                    value={filter?.date}
                    onChange={(date) => {
                      setState((prevState) => ({
                        ...prevState,
                        filter: {
                          date: date,
                          format: formatDate(date, 'YYYY'),
                        },
                      }));
                    }}
                    isShowTrigger={true}
                  />
                </div>

                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip id={`tooltip-top`}>Download XLS</Tooltip>}
                >
                  <Button
                    variant="dark"
                    className="ms-2"
                    onClick={$handleDownload}
                    style={{ height: 30 }}
                  >
                    <HiOutlineCloudDownload size={18} color="white" />
                  </Button>
                </OverlayTrigger>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Page.Body className="bordered">
        <Table data={data}/>
      </Page.Body>
    </Page>
  );
};

export default ReportReceivableCustomerScreen;
